// ==========================================
// FOOTER.JSX - FOOTER COMPONENT
// Estate Experts Real Estate Website
// Professional footer with newsletter, navigation, and contact info
// ==========================================

import React, { useState } from 'react';
import { FaEnvelope, FaMapMarkerAlt, FaPaperPlane } from 'react-icons/fa';
import '../../../assets/css/Buyer/General/footer.css'; // CSS file import
import logo2 from "../../../assets/images/logo2.png";

function Footer() {
  // ==========================================
  // STATE MANAGEMENT
  // ==========================================
  
  // Newsletter email input state
  const [email, setEmail] = useState('');
  
  // Newsletter subscription status
  const [subscribed, setSubscribed] = useState(false);

  // ==========================================
  // HANDLER FUNCTIONS
  // ==========================================
  
  // Handle newsletter subscription
  const handleSubscribe = (e) => {
    e.preventDefault();
    
    if (email && email.includes('@')) {
      // Success - show confirmation
      setSubscribed(true);
      setEmail('');
      
      // Reset message after 3 seconds
      setTimeout(() => {
        setSubscribed(false);
      }, 3000);
    } else {
      alert('Please enter a valid email address');
    }
  };

  // ==========================================
  // RENDER
  // ==========================================
  
  return (
    <footer className="footer">
      <div className="footer-container">
        
        {/* ==========================================
            MAIN FOOTER CONTENT - 5 Columns
            ========================================== */}
        <div className="footer-main">
          
          {/* COLUMN 1 - BRAND & NEWSLETTER */}
          <div className="footer-column footer-brand">
            {/* Logo and Brand Name */}
            <a href="/" className="navbar-brand">
            <img src={logo2} alt="Estate Experts" className="navbar-logo" />

            {/* Text block */}
            <div className="navbar-brand-text-wrap">
              <span className="footer-brand-text">Estate Experts</span>
              <span className="footer-brand-tagline">
                Buy
                <span className="brand-tagline-dot">◆</span>
                Sell
                <span className="brand-tagline-dot">◆</span>
                Rent
              </span>
            </div>
          </a>
            
            {/* Tagline */}
            <p className="footer-tagline">
              Building Your Dreams<br />In Real Estate
            </p>
            
            {/* Newsletter Subscription */}
            {/* <div className="footer-newsletter">
              <h4>Subscribe to our news</h4>
              <p className="home-newsletter-description">
                Stay informed and never miss a beat:<br />
                subscribe to our exclusive news updates!
              </p> */}
              
              {/* Newsletter Form */}
              {/* <form onSubmit={handleSubscribe} className="home-newsletter-form">
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="home-newsletter-input"
                  required
                />
                <button 
                  type="submit" 
                  className="home-newsletter-btn"
                >
                  Subscribe
                </button>
              </form>
               */}
              {/* Success Message */}
              {/* {subscribed && (
                <p className="newsletter-success">
                  ✓ Successfully subscribed!
                </p>
              )} */}
            {/* </div> */}
          </div>

          {/* COLUMN 2 - QUICK NAVIGATION */}
          <div className="footer-column">
            <h4 className="footer-column-title">Quick Navigation</h4>
            <ul className="genfooter-links">
              <li><a href="/">Home</a></li>
              <li><a href="/properties">Our Properties</a></li>
              <li><a href="/Agents">Agents</a></li>
              <li><a href="/About">About Us</a></li>
              <li><a href="/Blogs">Blogs</a></li>
              <li><a href="/Contact">Contact Us</a></li>
            </ul>
          </div>

          {/* COLUMN 3 - PROPERTIES */}
          <div className="footer-column">
            <h4 className="footer-column-title">Properties</h4>
            <ul className="genfooter-links">
              <li><a href="#apartments">Apartments for Sale</a></li>
              <li><a href="#villas">Villas for Sale</a></li>
              <li><a href="#townhouses">Townhouses for Sale</a></li>
              <li><a href="#new-developments">New Developments</a></li>
              <li><a href="#luxury">Luxury Properties</a></li>
              <li><a href="#seaview">Sea View Properties</a></li>
              <li><a href="#downtown">Downtown Properties</a></li>
            </ul>
          </div>

          {/* COLUMN 4 - RESOURCES */}
          <div className="footer-column">
            <h4 className="footer-column-title">Resources</h4>
            <ul className="genfooter-links">
              <li><a href="#blog">Blog</a></li>
              <li><a href="#faqs">FAQs</a></li>
              <li><a href="#buying-guide">Buying Guide</a></li>
              <li><a href="#selling-guide">Selling Guide</a></li>
              <li><a href="#area-guides">Area Guides</a></li>
              <li><a href="#news">Real Estate News</a></li>
            </ul>
          </div>

          {/* COLUMN 5 - CONTACT & LOCATION */}
          <div className="footer-column footer-contact">
            <h3 className="footer-contact-heading">
              We are here to change<br />your future.
            </h3>
            
            {/* Contact Actions */}
            <div className="footer-contact-actions">
              <a href="/contact" className="contact-btn">
                Contact Us
              </a>
              <a href="mailto:info@estateexperts.com" className="contact-icon-btn">
                <FaEnvelope />
              </a>
              <a href="#location" className="contact-icon-btn">
                <FaPaperPlane />
              </a>
            </div>
            
            {/* Map Image */}
            <div className="footer-map">
              <img 
                src="https://images.unsplash.com/photo-1524661135-423995f22d0b?w=400&h=250&fit=crop&q=80" 
                alt="Dubai Marina Location Map"
                className="map-image"
              />
              <div className="map-marker">
                <FaMapMarkerAlt />
              </div>
            </div>
            
            {/* Address */}
            <address className="footer-address">
              123 Zayed Road,<br />
              Dubai Marina,<br />
              Dubai, United Arab Emirates
            </address>
          </div>
        </div>

        {/* ==========================================
            FOOTER BOTTOM - Copyright & Links
            ========================================== */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            Copyright 2025 © Estate Experts
          </p>
          <div className="footer-legal">
            <a href="#terms">Terms of Service</a>
            <span className="footer-divider">|</span>
            <a href="#privacy">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
